import { render, staticRenderFns } from "./QrCodeContact.vue?vue&type=template&id=6eb96da4&scoped=true&"
import script from "./QrCodeContact.vue?vue&type=script&lang=js&"
export * from "./QrCodeContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb96da4",
  null
  
)

export default component.exports